import { PropertyDataType, } from '@debbie/common/dist/properties/index.js';
import moment from 'moment';
import React from 'react';
import { useSelector } from 'react-redux';
import Checkbox from '../Checkbox.js';
import DateInput from '../DateInput.js';
import Input from '../Input.js';
import MoneyInput from '../MoneyInput.js';
import Select from '../Select.js';
import Textarea from '../Textarea.js';
const PropertyValueInput = ({ propertyType, value, onChange, disabled, showCheckboxLabel = true, }) => {
    const lang = useSelector((state) => state.lang);
    const common = { disabled, placeholder: propertyType.label };
    switch (propertyType.type) {
        case PropertyDataType.checkbox:
            return (React.createElement(Checkbox, { ...common, placeholder: showCheckboxLabel ? propertyType.label : undefined, checkMark: true, checked: value === true, onChange: (event) => onChange(event.target.checked) }));
        case PropertyDataType.datePicker:
            return (React.createElement(DateInput, { ...common, allowNull: true, value: typeof value === 'string' && value !== '' ? moment(value) : null, onChange: (date) => onChange(date?.format('YYYY-MM-DD') ?? null) }));
        case PropertyDataType.dropdown:
            return (React.createElement(Select, { disabled: disabled, portal: true, label: typeof value === 'string'
                    ? (propertyType.data?.options.find((option) => option.value === value)?.text ?? propertyType.label)
                    : propertyType.label, title: propertyType.label, searchPlaceholder: lang.misc.search, options: [
                    { value: '', label: '—' },
                    ...(propertyType.data?.options ?? []).map((option) => ({
                        value: option.value,
                        label: option.text,
                    })),
                ], selected: typeof value === 'string' && value !== '' ? [value] : [], onChange: (selected) => onChange(selected[0] === '' ? null : (selected[0] ?? null)) }));
        case PropertyDataType.money:
            return (React.createElement(MoneyInput, { ...common, allowNull: true, value: typeof value === 'number' ? value : null, onChange: onChange }));
        case PropertyDataType.number:
            return (React.createElement(Input, { ...common, type: "number", step: "any", value: typeof value === 'number' ? value : '', onChange: (event) => onChange(event.target.value === '' ? null : Number(event.target.value)) }));
        case PropertyDataType.multiLineText:
            return (React.createElement(Textarea, { ...common, value: typeof value === 'string' ? value : '', onChange: (event) => onChange(event.target.value) }));
        case PropertyDataType.singleLineText:
            return (React.createElement(Input, { ...common, value: typeof value === 'string' ? value : '', onChange: (event) => onChange(event.target.value) }));
    }
    return null;
};
export default PropertyValueInput;
//# sourceMappingURL=PropertyValueInput.js.map